import type { TFilesModule } from '@/store/modules/client/files/types'

import { actions } from '@/store/modules/client/files/actions'

export const files: TFilesModule = {
  namespaced: true,
  actions,
}
